import _ from 'lodash';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const initPoint = {
  pointInfo: [],
  pointList: [],
  pointListPageSize: 20,
  pointListPageNo: 1,
  pointListStartDate: '',
  pointListEndDate: '',
  pointListStatus: 0,
};

const point = _.cloneDeep(initPoint);

const defaultState = {
  initPoint,
  point,
};

export default {
  namespaced: true,
  state: defaultState,
  actions,
  getters,
  mutations,
};
